import { Text } from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { ComponentType } from "react";
import * as Flex from "@repo/ui/flex";
import * as Viewport from "@/components/viewport";
import AnimatedCtaLink from "../../animated-cta-link/animated-cta-link";
import { Feature } from "../types";
import styles from "./feature.module.css";

interface FeatureProps {
  feature: Feature;
  usedInCarousel?: boolean;
  playVideo?: boolean;
}

function withCtaText<P extends FeatureProps>(
  WrappedComponent: ComponentType<P>,
) {
  const ComponentWithCta = (props: P) => {
    const {
      feature: {
        ctaLink: { jsonValue: ctaLink },
        ctaText: { jsonValue: ctaText },
        subheading,
      },
    } = props;

    return (
      <>
        <WrappedComponent {...props} />
        <Flex.Container column align="center" gap="sm">
          <Text
            tag="p"
            field={subheading}
            className={clsx(styles.gridText, "typographyBody3Sentence")}
          />
          <Viewport.Large>
            {ctaLink.value?.href && ctaText.value && (
              <AnimatedCtaLink
                className={clsx(styles.ctaLink, "typographyLabel3")}
                link={{
                  ...ctaLink,
                  value: {
                    ...ctaLink.value,
                    text: ctaText.value,
                  },
                }}
              />
            )}
          </Viewport.Large>
        </Flex.Container>
      </>
    );
  };
  return ComponentWithCta;
}

export default withCtaText;
